import { AstraGameReport } from './AstraReport';

export interface AstraSeries { id: string; startedAt: string; games: AstraGameReport[] }
function database(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('zodiac-playtest-series', 1);
    request.onupgradeneeded = () => request.result.createObjectStore('series', { keyPath: 'id' });
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}
export async function saveSeries(series: AstraSeries): Promise<void> {
  const db = await database();
  try {
    await new Promise<void>((resolve, reject) => {
      const transaction = db.transaction('series', 'readwrite');
      transaction.objectStore('series').put(series);
      transaction.oncomplete = () => resolve();
      transaction.onerror = () => reject(transaction.error);
      transaction.onabort = () => reject(transaction.error);
    });
  } finally { db.close(); }
}
export async function loadSeries(id: string): Promise<AstraSeries | undefined> {
  const db = await database();
  try {
    return await new Promise<AstraSeries | undefined>((resolve, reject) => {
      const request = db.transaction('series').objectStore('series').get(id);
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  } finally { db.close(); }
}
export function downloadSeries(series: AstraSeries): void {
  const url = URL.createObjectURL(new Blob([JSON.stringify(series, null, 2)], { type: 'application/json' }));
  const link = document.createElement('a');
  link.href = url; link.download = `${series.id}.json`; link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
